import React from "react";
import { Flame } from "lucide-react";

export default function FacebookAvatar() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Facebook Profile Picture · 1080×1080
        </p>
        <div
          data-testid="fb-avatar"
          className="relative w-[540px] h-[540px] flex items-center justify-center overflow-hidden"
          style={{
            background:
              "radial-gradient(circle at 50% 35%, rgba(255,140,0,0.35), rgba(255,59,48,0.15) 35%, #0a0606 65%, #000 100%)",
          }}
        >
          {/* Outer ring — sits inside the circle FB crops to */}
          <div
            aria-hidden="true"
            className="absolute inset-[8%] rounded-full border-[3px] border-[#FF3B30]/30"
          />
          {/* Subtle grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-25 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          <div className="relative z-10 flex flex-col items-center text-center">
            <Flame
              className="text-[#FF3B30] drop-shadow-[0_0_30px_rgba(255,59,48,0.6)]"
              style={{ width: 56, height: 56, marginBottom: 8 }}
            />
            <h1
              className="font-['Anton'] uppercase text-white leading-[0.85]"
              style={{ fontSize: 92, letterSpacing: "-0.02em" }}
            >
              Smokey
            </h1>
            <h1
              className="font-['Anton'] uppercase leading-[0.85] mt-1"
              style={{ fontSize: 130, letterSpacing: "-0.02em" }}
            >
              <span className="text-[#FF3B30] drop-shadow-[0_0_25px_rgba(255,59,48,0.5)]">
                AF
              </span>
            </h1>
            <div className="mt-4 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase tracking-[0.5em] text-[#FF8C00]"
                style={{ fontSize: 14 }}
              >
                Barbecue
              </span>
              <span className="h-px w-10 bg-[#FF8C00]" />
            </div>
          </div>
        </div>

        <a
          href="/smokey-af-fb-avatar.png"
          download
          data-testid="fb-download-link"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
